import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { convertToInternationalCurrencySystem } from '../../service/Util';

class DisplayStockPrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbolName: this.props.symbolName,
            ticker: this.props.ticker,
            price: 0,
            change: 0,
            changesPercentage: 0,
            volume: 0
        };
    }

    componentDidMount() {
        console.log('DisplayStockPrice', this.state.ticker);
        ApiService.getQuotes(this.state.ticker)
            .then(result => {
                console.log('stockData', result)
                for (var i = 0; i < result.length; i++) {
                    this.setState({
                        price: result[i].price,
                        change: result[i].change,
                        changesPercentage: result[i].changesPercentage,
                        volume: result[i].volume
                    });
                }

                if (result !== undefined && result.length <= 0) {
                    this.setState({
                        price: 0,
                        change: 0,
                        changesPercentage: 0,
                        volume: 0
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }

    render() {
        return (
            <Container>
                <Row>
                    <Col style={{ fontWeight: 'bold' }}>{this.state.symbolName}</Col>
                    <Col style={{ fontSize: '10px', fontWeight: 'bold', color: parseFloat(this.state.change) >= 0 ? 'green' : 'red' }}>
                        {parseFloat(this.state.price).toFixed(0)}&nbsp;&nbsp;&nbsp;
                        {parseFloat(this.state.change).toFixed(2)}&nbsp;
                        ({parseFloat(this.state.changesPercentage).toFixed(2)}%)
                    </Col>
                    <Col style={{ fontSize: '10px', fontWeight: 'bold'}}>
                        Vol:{convertToInternationalCurrencySystem(parseFloat(this.state.volume).toFixed(0))}
                    </Col>
                </Row>
            </Container>
        );

    }
}

export default DisplayStockPrice;
